// extracted by mini-css-extract-plugin
export default {"container":"RecipePreparationFields_container__VLMWG","headline":"RecipePreparationFields_headline__Xye5x","headlineContainer":"RecipePreparationFields_headlineContainer__IVlWI"};